module.exports = __webpack_public_path__ + "static/media/ForsytsHRDark.5ce57b64.svg";